export default "__VITE_ASSET__BHtwbJ3h__"